import { render, staticRenderFns } from "./DeliveryBasic.vue?vue&type=template&id=aacd8bf2"
import script from "./DeliveryBasic.vue?vue&type=script&lang=js"
export * from "./DeliveryBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports